import one from "../assets/images/one.jpg";
import two from "../assets/images/two.jpg";
import three from "../assets/images/three.jpg";
export const Carousel = () => {
  return (
    <div id="carouselExampleIndicators" className="carousel slide index-carousel">
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img height={"450px"} src={one} className="d-block w-100" alt="..." />
        </div>
        <div className="carousel-item">
          <img height={"450px"} src={two} className="d-block w-100" alt="..." />
        </div>
        <div className="carousel-item">
          <img
            height={"450px"}
            src={three}
            className="d-block w-100"
            alt="..."
          />
        </div>
      </div>
    </div>
  );
};
